
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/radical-candor",
      function () {
        return require("private-next-pages/books/radical-candor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/radical-candor"])
      });
    }
  